import React, { FC, useMemo } from 'react';
import { getConfigByExtension } from '@helpers';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';

const DocumentPreviewIcon = ({ extension, C, small = false, scale = initialScale }) => {
  const iconConfig = useMemo(() => {
    if (!extension) return null;
    return getConfigByExtension(extension?.toLowerCase());
  }, [extension]);

  if (!iconConfig) return null;

  return (
    <>
      {iconConfig && (
        <View
          style={[
            { marginVertical: scale(small ? 4 : 8) },
            iconConfig.withWrapper && {
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            },
            iconConfig?.wrapperStyles && iconConfig.wrapperStyles,
            !small &&
              iconConfig.withWrapper && { width: scale(61), height: scale(61), backgroundColor: C('Gray/Light/6'), borderRadius: scale(12.2) },
          ]}
        >
          <Svg
            icon={iconConfig?.icon}
            width={scale(iconConfig?.getWidth(small))}
            height={scale(iconConfig?.getHeight(small))}
            {...(iconConfig?.color ? { color: C(iconConfig.color) } : {})}
          />
        </View>
      )}
    </>
  );
};

export { DocumentPreviewIcon };
